import React, { useEffect, useState } from "react";
import "../../Assets/css/PublicPage.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaSpotify,
  FaTiktok,
  FaFacebook,
  FaLinkedin,
  FaWhatsapp,
  FaSnapchat,
  FaGlobe,
  FaRegCopy,
  FaPlay,
  FaRegLemon,
  FaWpforms,
} from "react-icons/fa";
import L from "leaflet";
import Slider from "react-slick";
import { toast } from "react-toastify";
import { IoMail } from "react-icons/io5";
import { LuPhone } from "react-icons/lu";
import { TbWorld } from "react-icons/tb";
import { IoLocationSharp } from "react-icons/io5";
import { HiShoppingBag } from "react-icons/hi2";
import { Link, useParams } from "react-router-dom";
import { Button, Carousel, Row } from "react-bootstrap";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import Queue from "./Queue";
import AlbumEmbed from "./AlbumEmbed";
import user from "../../Assets/photo/user.png";
import CustomAudioPill from "./CustomAudioPill";
import EventPosterModal from "./EventPosterModal";
import axiosUserInstance from "../../axiosUserInstance";
import { settings1x, settings2x } from "../../utils/constant";
import { extractYoutubeId, hexToRgba } from "../../utils/common";
import LoadingImage from "../Common/LoadingImage";
import LoadingVideo from "../Common/LoadingVideo";
import { BiArrowFromLeft } from "react-icons/bi";
import FormWidgetModal from "../Form/FormWidgetModal";

const socialIcons = {
  instagram: <FaInstagram />,
  twitter: <FaTwitter />,
  youtube: <FaYoutube />,
  spotify: <FaSpotify />,
  tiktok: <FaTiktok />,
  facebook: <FaFacebook />,
  linkedin: <FaLinkedin />,
  whatsapp: <FaWhatsapp />,
  snapchat: <FaSnapchat />,
  website: <FaGlobe />,
  lemon8: <FaRegLemon />,
  shop: <HiShoppingBag />,
};

const icon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
  iconSize: [32, 32],
});

const PublicPage = () => {
  const { userName } = useParams();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [error, setError] = useState(null);
  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [activeAlbum, setActiveAlbum] = useState(null);
  const [youtubeId, setYoutubeId] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [formModalData, setFormModalData] = useState(null);

  useEffect(() => {
    const setVh = () => {
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    };

    setVh();
    window.addEventListener("resize", setVh);
    return () => window.removeEventListener("resize", setVh);
  }, []);

  useEffect(() => {
    if (!userName) {
      setNotFound(true);
      setLoading(false);
      return;
    }

    const fetchUserData = async () => {
      try {
        const response = await axiosUserInstance.get(
          `user/fetchUserByUserName/${userName}`
        );
        const data = response?.data?.data || null;

        if (!data) {
          setNotFound(true);
        } else {
          // Normalize new widget structure (widgets array) into legacy shape
          const normalizeUserWidget = (uw) => {
            if (!uw) return {};
            // if already flattened, return as is
            if (!Array.isArray(uw.widgets)) return uw;

            const out = {
              eventPoster: uw.eventPoster || {},
              widgets: uw.widgets,
            };

            uw.widgets.forEach((w) => {
              switch (w.type) {
                case "title":
                  out.title = out.title || [];
                  if (w.text) out.title.push(w.text);
                  break;
                case "description":
                  out.description = out.description || [];
                  if (w.text) out.description.push(w.text);
                  break;
                case "note":
                  out.note = out.note || [];
                  if (w.text) out.note.push(w.text);
                  break;
                case "email":
                  out.email = out.email || [];
                  if (w.text) out.email.push(w.text);
                  break;
                case "number":
                  out.number = out.number || [];
                  if (w.text) out.number.push(w.text);
                  break;
                case "card":
                  out.card = out.card || [];
                  out.card.push({
                    email: w.email || "",
                    number: w.number || "",
                    website: w.website || "",
                  });
                  break;
                case "queue":
                  out.queue = out.queue || [];
                  out.queue.push(w);
                  break;
                case "albumEmbed":
                  out.albumEmbed = out.albumEmbed || [];
                  out.albumEmbed.push(w);
                  break;
                case "youtube":
                  out.youtube = out.youtube || [];
                  if (w.content) out.youtube.push(w.content);
                  break;
                case "mapDetails":
                  out.mapDetails = w;
                  break;
                default:
                  break;
              }
            });

            return out;
          };

          const normalizedWidget = normalizeUserWidget(data.userWidget);

          setUserData({
            id: data._id,
            fullName: data.name || data.userName,
            status: data.status || "",
            username: data.userName ? `@${data.userName}` : "",
            title: data.profileTitle || "",
            bio: data.bio || "",
            bioScore: data.bioScore || 0,
            image: data.profileImage || "",
            bannerImage: data.bannerImage || "",
            audioUrl: data?.audioUrl || "",
            showAudio: data?.showAudio || false,
            socialLinks: Array.isArray(data.socialLinks)
              ? data.socialLinks
              : [],
            links: Array.isArray(data.links) ? data.links : [],
            userWidget: normalizedWidget,
            albums: Array.isArray(data.albums) ? data.albums : [],
            tags: Array.isArray(data.tags) ? data.tags : [],
            planType: data?.planType?.type || "free",
            activeThemeUrl: data?.activeThemeUrl ? data?.activeThemeUrl : "",
            pageTheme: data?.pageTheme,
            formTheme: data?.formTheme,
            activeAlbumLayout: data?.activeAlbumLayout
              ? data?.activeAlbumLayout
              : "grid2",
            socialLinkTheme: data?.socialLinkTheme
              ? data?.socialLinkTheme
              : {
                  background: "#f9f9f9",
                  backgroundOpacity: 1,
                  backgroundBorderWidth: 1,
                  backgroundBorder: "rgba(0, 0, 0, 0.05)",
                  backgroundRadius: 8,
                  thumbnailRadius: 8,
                  titleColor: "#2d3436",
                  subtitleColor: "#777777",
                  iconColor: "#777",
                  buttonTextColor: "#6c5ce7",
                  buttonBorder: "#6c5ce7",
                  buttonBackground: "#f9f9f9",
                  buttonRadius: 8,
                },
          });

          if (normalizedWidget?.youtube) {
            const ids = normalizedWidget.youtube.map((url) =>
              extractYoutubeId(url)
            );
            setYoutubeId(ids);
          }
        }
      } catch (err) {
        if (err?.response?.status === 404) {
          setNotFound(true);
        } else {
          setError(
            err?.response?.data?.message ||
              err?.message ||
              "An unexpected error occurred."
          );
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
    userVisitCount();
  }, [userName]);

  useEffect(() => {
    const backgroundRadius = userData?.pageTheme?.backgroundRadius;
    if (backgroundRadius) {
      document.documentElement.style.setProperty(
        "--album-item-radius",
        `${backgroundRadius}px`
      );
    }
  }, [userData]);

  const userVisitCount = async () => {
    try {
      await axiosUserInstance.post(`profile-analytics/visit/${userName}`);
    } catch (err) {
      console.error("Error recording visit:", err);
    }
  };

  const handleAlbumClick = (album) => {
    setActiveAlbum(album);
    setShowModal(true);
  };

  const handleOpenFormModal = async (widget) => {
    setFormModalData({
      widgetId: widget._id,
      requiredFields: [],
      removedFields: [],
    });

    if (widget.formCollection) {
      const formCollection = widget.formCollection;
      setFormModalData((prev) => ({
        ...prev,
        requiredFields: Object.keys(formCollection).filter(
          (key) => formCollection[key].isRequired
        ),
        removedFields: Object.keys(formCollection).filter(
          (key) => formCollection[key].isRemove
        ),
      }));
    }

    try {
      const resp = await axiosUserInstance.get("/user/form/response", {
        params: { widgetId: widget._id, userName, _ts: Date.now() },
        skipAuth: true,
      });
      if (resp?.status === 200 && resp.data?.data) {
        const { formData } = resp.data.data;
        setFormModalData((prev) => ({ ...prev, ...formData }));
      }
    } catch (err) {
      if (err?.response?.status && err.response.status !== 404) {
        console.error("Error fetching previous form response:", err);
        const msg =
          err?.response?.data?.message ||
          err.message ||
          "Unable to load previous form data";
        toast.error(msg);
      }
    }

    setShowFormModal(true);
  };

  const handleCloseFormModal = () => {
    setShowFormModal(false);
    setFormModalData(null);
  };

  if (loading)
    return (
      <div
        className="pg-container"
        style={{ fontFamily: userData?.pageTheme?.pageFont }}
      >
        Loading...
      </div>
    );
  if (error || notFound)
    return (
      <div className="notfound-container">
        <div className="notfound-content">
          <div className="notfound-icon">✳</div>
          <h2 style={{ fontFamily: userData?.pageTheme?.pageFont }}>
            The page you're looking for doesn't exist.
          </h2>
          <p style={{ fontFamily: userData?.pageTheme?.pageFont }}>
            Want this to be your username?{" "}
            <a href="/">Create your BioME now.</a>
          </p>
        </div>
        <footer className="notfound-footer logo">BioME.com</footer>
      </div>
    );

  return (
    <div className="pg-wrapper">
      <div className="pg-container">
        <div
          className="pg-profile-content position-relative"
          style={{
            "--bg-url": `url(${userData?.activeThemeUrl})`,
            // background: `url(${userData?.activeThemeUrl}) no-repeat fixed center / cover`,
          }}
        >
          {/* Banner */}
          {userData.bannerImage ? (
            <div
              className="profile-banner"
              style={{ marginBottom: userData.image ? "-70px" : "12px" }}
            >
              <LoadingImage
                src={userData.bannerImage}
                alt="banner"
                className="pg-banner-img"
                width="100%"
                height="auto"
                skeletonHeight="250px"
              />
              {/* <div className="bioscore" title="BioScore">
                <FaStar />
                <span style={{ marginLeft: 6 }}>{userData.bioScore}</span>
                <div className="bioscore-tooltip">
                  BioScore flaunts an individual's profile popularity. For every
                  1 unique view, 3 BioScore is earned!
                </div>
              </div> */}
            </div>
          ) : (
            <></>
            // <div className="bioscore" title="BioScore">
            //   <FaStar />
            //   <span style={{ marginLeft: 6 }}>{userData.bioScore}</span>
            //   <div className="bioscore-tooltip">
            //     BioScore flaunts an individual's profile popularity. For every 1
            //     unique view, 3 BioScore is earned!
            //   </div>
            // </div>
          )}

          {/* Profile */}
          {userData.image && (
            <LoadingImage
              src={userData.image}
              alt={userData.username}
              className="pg-profile-picture"
              width="120px"
              height="120px"
              skeletonHeight="120px"
              style={{
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          )}
          <h1
            className="pg-profile-name"
            style={{
              color: userData?.pageTheme?.titleColor,
              fontFamily: userData?.pageTheme?.pageFont,
            }}
          >
            {userData?.fullName}
          </h1>
          {userData?.title && (
            <h2
              className="pg-profile-title"
              style={{
                color: userData?.pageTheme?.titleColor,
                fontFamily: userData?.pageTheme?.pageFont,
              }}
            >
              {userData?.title}
            </h2>
          )}
          {userData?.bio && (
            <p
              className="pg-profile-subtitle"
              style={{
                color: userData?.pageTheme?.subtitleColor,
                fontFamily: userData?.pageTheme?.pageFont,
              }}
            >
              {userData?.bio}
            </p>
          )}

          {/* Traits */}
          <div className="profile-traits">
            {userData?.tags
              ?.filter((item) => item?.isActive)
              ?.map((t) => (
                <div
                  key={t._id}
                  className="trait-pill"
                  style={{
                    borderRadius: `${userData?.pageTheme?.backgroundRadius}px`,
                    fontFamily: userData?.pageTheme?.pageFont,
                  }}
                >
                  {t?.name}
                </div>
              ))}
          </div>

          {/* Links */}
          {userData.links.length > 0 && (
            <div className="pg-links-section">
              {userData?.links.map((link, i) => (
                <a
                  key={i}
                  href={link.url}
                  className="pg-link-card"
                  target="_blank"
                  rel="noreferrer"
                >
                  <LoadingImage
                    src={link.img || "https://via.placeholder.com/50"}
                    alt={link.title}
                    className="pg-link-img"
                    width="50px"
                    height="50px"
                    skeletonHeight="50px"
                  />
                  <span style={{ fontFamily: userData?.pageTheme?.pageFont }}>
                    {link?.title}
                  </span>
                </a>
              ))}
            </div>
          )}

          {/* User Widget */}
          {userData?.userWidget &&
            Object.keys(userData?.userWidget).length > 0 && (
              <div className="pg-widget-section">
                {/* If widgets array exists, render widgets in order */}
                {Array.isArray(userData?.userWidget?.widgets) &&
                userData.userWidget.widgets.length > 0 ? (
                  userData.userWidget.widgets
                    .slice()
                    .sort((a, b) => (a.order || 0) - (b.order || 0))
                    .map((w, idx) => {
                      const key = `${w.type}-${w._id || idx}`;
                      switch (w?.type) {
                        case "albums": {
                          const selectedIds = Array.isArray(w?.albumIds)
                            ? w?.albumIds?.map((x) => String(x))
                            : [];
                          // const albumsToShow =
                          //   selectedIds.length > 0
                          //     ? (userData?.albums || []).filter((album) =>
                          //         selectedIds.includes(String(album?._id))
                          //       )
                          //     : userData?.albums || [];

                          // if (!albumsToShow.length) return null;

                          // Build a flat list of { album, item } for only selected media
                          const albumsToShow = [];
                          (userData?.albums || [])?.forEach((album) => {
                            (album?.media || [])?.forEach((item) => {
                              if (
                                selectedIds?.length === 0 ||
                                selectedIds?.includes(String(item?._id))
                              ) {
                                albumsToShow?.push({ album, item });
                              }
                            });
                          });

                          if (!albumsToShow?.length) return null;

                          return (
                            <div key={key} className="pg-albums-section">
                              {userData?.activeAlbumLayout?.includes("grid") ? (
                                <div
                                  className={`album-grid ${userData?.activeAlbumLayout}`}
                                >
                                  {albumsToShow?.map(({ album, item }, i) =>
                                    item?.type?.startsWith("video/") ? (
                                      <div
                                        key={i}
                                        className="album-item d-flex align-items-center"
                                        onClick={() => handleAlbumClick(album)}
                                        style={{
                                          cursor: "pointer",
                                          borderRadius: `${userData?.pageTheme?.backgroundRadius}px`,
                                        }}
                                      >
                                        <LoadingVideo
                                          src={item?.url}
                                          type={item?.type}
                                          width="100%"
                                          height="auto"
                                          autoPlay
                                          loop
                                          muted
                                          controls={false}
                                          skeletonHeight="200px"
                                          playsInline
                                        />
                                        <div
                                          className="album-name"
                                          style={{
                                            fontFamily:
                                              userData?.pageTheme?.pageFont,
                                          }}
                                        >
                                          {album?.name}
                                        </div>
                                      </div>
                                    ) : (
                                      <div
                                        key={i}
                                        className="album-item"
                                        onClick={() => handleAlbumClick(album)}
                                        style={{
                                          cursor: "pointer",
                                          display: "flex",
                                        }}
                                      >
                                        <LoadingImage
                                          src={item?.url}
                                          alt={album?.name || "Album"}
                                          className="album-media"
                                          width="100%"
                                          height="auto"
                                          skeletonHeight="200px"
                                        />
                                        <div
                                          className="album-name"
                                          style={{
                                            fontFamily:
                                              userData?.pageTheme?.pageFont,
                                          }}
                                        >
                                          {album?.name}
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              ) : (
                                <div className="album-slick-slider">
                                  {userData?.activeAlbumLayout === "slick1" ? (
                                    <Slider {...settings1x}>
                                      {albumsToShow?.map(
                                        ({ album, item }, i) => (
                                          <div
                                            key={i}
                                            className="album-item d-flex"
                                            onClick={() =>
                                              handleAlbumClick(album)
                                            }
                                            style={{
                                              cursor: "pointer",
                                            }}
                                          >
                                            {item?.type?.startsWith(
                                              "video/"
                                            ) ? (
                                              <LoadingVideo
                                                src={item?.url}
                                                type={item?.type}
                                                width="100%"
                                                height="auto"
                                                autoPlay
                                                loop
                                                muted
                                                controls={false}
                                                skeletonHeight="200px"
                                                playsInline
                                              />
                                            ) : (
                                              <LoadingImage
                                                src={item?.url}
                                                alt={album?.name || "Album"}
                                                className="album-media"
                                                width="100%"
                                                height="auto"
                                                skeletonHeight="200px"
                                              />
                                            )}
                                            {album?.name && (
                                              <div
                                                className="album-name"
                                                style={{
                                                  fontFamily:
                                                    userData?.pageTheme
                                                      ?.pageFont,
                                                }}
                                              >
                                                {album?.name}
                                              </div>
                                            )}
                                          </div>
                                        )
                                      )}
                                    </Slider>
                                  ) : userData?.activeAlbumLayout ===
                                    "slick2" ? (
                                    <Slider {...settings2x}>
                                      {albumsToShow?.map(
                                        ({ album, item }, i) => (
                                          <div
                                            key={i}
                                            className="album-item d-flex"
                                            onClick={() =>
                                              handleAlbumClick(album)
                                            }
                                            style={{
                                              cursor: "pointer",
                                            }}
                                          >
                                            {item?.type?.startsWith(
                                              "video/"
                                            ) ? (
                                              <LoadingVideo
                                                src={item?.url}
                                                type={item?.type}
                                                width="100%"
                                                height="auto"
                                                autoPlay
                                                loop
                                                muted
                                                controls={false}
                                                skeletonHeight="200px"
                                                playsInline
                                              />
                                            ) : (
                                              <LoadingImage
                                                src={item?.url}
                                                alt={album?.name || "Album"}
                                                className="album-media"
                                                width="100%"
                                                height="auto"
                                                skeletonHeight="200px"
                                              />
                                            )}
                                            {album?.name && (
                                              <div
                                                className="album-name"
                                                style={{
                                                  fontFamily:
                                                    userData?.pageTheme
                                                      ?.pageFont,
                                                }}
                                              >
                                                {album?.name}
                                              </div>
                                            )}
                                          </div>
                                        )
                                      )}
                                    </Slider>
                                  ) : null}
                                </div>
                              )}
                            </div>
                          );
                        }
                        case "title":
                          return (
                            <h4
                              key={key}
                              className="widget-title-item py-1"
                              style={{
                                wordWrap: "break-word",
                                fontFamily: userData?.pageTheme?.pageFont,
                              }}
                            >
                              {w?.text}
                            </h4>
                          );
                        case "description":
                          return (
                            <p
                              key={key}
                              className="widget-title-item mb-2 py-1"
                              style={{
                                fontFamily: userData?.pageTheme?.pageFont,
                              }}
                            >
                              {w?.text}
                            </p>
                          );
                        case "note":
                          return (
                            <p
                              key={key}
                              className="widget-title-item mb-2 py-1"
                              style={{
                                fontFamily: userData?.pageTheme?.pageFont,
                              }}
                            >
                              {w?.text}
                            </p>
                          );
                        case "email":
                          return (
                            <p key={key} className="py-1 mb-2">
                              <IoMail className="me-2" />
                              <a
                                href={`mailto:${w.text}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  fontFamily: userData?.pageTheme?.pageFont,
                                }}
                              >
                                {w?.text}
                              </a>
                            </p>
                          );
                        case "number":
                          return (
                            <p key={key} className="py-1 mb-2">
                              <LuPhone className="me-2" />
                              <a
                                href={`tel:${w.text}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  fontFamily: userData?.pageTheme?.pageFont,
                                }}
                              >
                                {w?.text}
                              </a>
                            </p>
                          );
                        case "form":
                          return (
                            <button
                              className="my-form-btn"
                              onClick={() => handleOpenFormModal(w)}
                              style={{
                                fontFamily: userData?.pageTheme?.pageFont,
                                backgroundColor:
                                  userData?.formTheme?.buttonColor || undefined,
                                borderRadius:
                                  typeof userData?.formTheme?.borderRadius ===
                                  "number"
                                    ? userData.formTheme.borderRadius
                                    : undefined,
                              }}
                            >
                              <FaWpforms size={24} />
                              My Form
                              <BiArrowFromLeft size={24} />
                            </button>
                          );
                        case "card":
                          return (
                            <div
                              key={key}
                              className="mb-2 bg-light p-2 rounded text-center"
                            >
                              {w?.website ? (
                                <p className="mb-1">
                                  <TbWorld className="me-2" />
                                  <a
                                    href={
                                      w.website.startsWith("http")
                                        ? w.website
                                        : `https://${w?.website}`
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                      fontFamily: userData?.pageTheme?.pageFont,
                                    }}
                                  >
                                    {w?.website}
                                  </a>
                                </p>
                              ) : null}
                              {w?.email ? (
                                <p className="mb-1">
                                  <IoMail className="me-2" />
                                  <a
                                    href={`mailto:${w.email}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                      fontFamily: userData?.pageTheme?.pageFont,
                                    }}
                                  >
                                    {w?.email}
                                  </a>
                                </p>
                              ) : null}
                              {w?.number ? (
                                <p className="mb-1">
                                  <LuPhone className="me-2" />
                                  <a
                                    href={`tel:${w?.number}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                      fontFamily: userData?.pageTheme?.pageFont,
                                    }}
                                  >
                                    {w?.number}
                                  </a>
                                </p>
                              ) : null}
                            </div>
                          );
                        case "queue":
                          return (
                            <Queue
                              key={key}
                              userData={{
                                ...userData,
                                userWidget: { queue: [w] },
                              }}
                            />
                          );
                        case "albumEmbed":
                          return (
                            <AlbumEmbed
                              key={key}
                              userData={{
                                ...userData,
                                userWidget: { albumEmbed: [w] },
                              }}
                            />
                          );
                        case "youtube": {
                          const id = extractYoutubeId(w.content || "");
                          if (!id) return null;
                          return (
                            <div key={key} className="mb-4">
                              <div className="youtube-video-wrapper">
                                <iframe
                                  src={`https://www.youtube.com/embed/${id}`}
                                  title="YouTube video player"
                                  frameBorder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                  allowFullScreen
                                  style={{ width: "100%", height: "300px" }}
                                />
                              </div>
                            </div>
                          );
                        }
                        case "mapDetails":
                          // if (userData?.planType?.toLowerCase() !== "free" && w.isShow && w.lat && w.lon) {
                          if (
                            userData?.planType?.toLowerCase() !== "free" &&
                            w.lat &&
                            w.lon
                          ) {
                            return (
                              <div key={key}>
                                <div className="mb-2 rounded p-2 bg-light">
                                  <MapContainer
                                    center={[w.lat, w.lon]}
                                    zoom={15}
                                    dragging={false}
                                    scrollWheelZoom={false}
                                    doubleClickZoom={false}
                                    zoomControl={false}
                                    style={{ width: "100%", height: "250px" }}
                                  >
                                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                    <Marker
                                      position={[w.lat, w.lon]}
                                      icon={icon}
                                    ></Marker>
                                  </MapContainer>
                                  {w.label && (
                                    <div className="d-flex align-items-center justify-content-center mt-2">
                                      <IoLocationSharp
                                        className="me-1"
                                        style={{
                                          color: "#e50027",
                                          fontSize: "20px",
                                        }}
                                      />
                                      <p
                                        className="mb-0"
                                        style={{
                                          fontFamily:
                                            userData?.pageTheme?.pageFont,
                                        }}
                                      >
                                        {w?.label}
                                      </p>
                                    </div>
                                  )}
                                  <a
                                    href={`https://www.google.com/maps/search/?api=1&query=${w.lat},${w.lon}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                      display: "block",
                                      fontSize: "14px",
                                      fontFamily: userData?.pageTheme?.pageFont,
                                    }}
                                  >
                                    Open in Google Maps
                                  </a>
                                </div>
                              </div>
                            );
                          }
                          return null;
                        case "socialLink":
                          if (w.socialLink && w.socialLink.link) {
                            const icon =
                              socialIcons[w.socialLink.type?.toLowerCase()] ||
                              null;
                            return (
                              <a
                                key={key}
                                href={w.socialLink.link}
                                className="pg-social-link"
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  backgroundColor: hexToRgba(
                                    userData?.socialLinkTheme?.background,
                                    userData?.socialLinkTheme?.backgroundOpacity
                                  ),
                                  border: `${userData?.socialLinkTheme?.backgroundBorderWidth}px solid ${userData?.socialLinkTheme?.backgroundBorder}`,
                                  borderRadius: `${userData?.socialLinkTheme?.backgroundRadius}px`,
                                  color: userData?.socialLinkTheme?.titleColor,
                                }}
                              >
                                {w.socialLink?.thumbnailUrl ? (
                                  <LoadingImage
                                    src={w.socialLink.thumbnailUrl}
                                    alt="thumbnail"
                                    className="social-thumbnail me-0"
                                    width="32px"
                                    height="32px"
                                    skeletonHeight="32px"
                                    style={{
                                      width: "32px",
                                      minWidth: "32px",
                                      height: "32px",
                                      borderRadius: `${userData?.socialLinkTheme?.thumbnailRadius}px`,
                                    }}
                                  />
                                ) : (
                                  <span
                                    className="social-icon me-0"
                                    style={{
                                      color:
                                        userData?.socialLinkTheme?.iconColor,
                                    }}
                                  >
                                    {icon}
                                  </span>
                                )}
                                <span
                                  style={{
                                    color:
                                      userData?.socialLinkTheme?.titleColor,
                                    overflowWrap: "anywhere",
                                    fontFamily: userData?.pageTheme?.pageFont,
                                  }}
                                  className="w-100"
                                >
                                  {w.socialLink.label ||
                                    w.socialLink.type ||
                                    "Social Link"}
                                </span>
                                <button
                                  type="button"
                                  className="icon-btn"
                                  data-bs-toggle="tooltip"
                                  data-bs-title="Copy Link"
                                  data-bs-placement="top"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    navigator.clipboard.writeText(
                                      w.socialLink.link
                                    );
                                    toast.success("Link Copied to Clipboard!");
                                  }}
                                >
                                  <FaRegCopy
                                    color={
                                      userData?.socialLinkTheme?.titleColor
                                    }
                                  />
                                </button>
                              </a>
                            );
                          }
                          return null;
                        default:
                          return null;
                      }
                    })
                ) : (
                  /* Legacy rendering when widgets array not present */
                  <>
                    <AlbumEmbed userData={userData} />
                    <Queue userData={userData} />
                    {userData?.userWidget?.title &&
                      userData?.userWidget?.title?.length > 0 && (
                        <div className="mb-3">
                          {userData?.userWidget?.title?.map((t, idx) => (
                            <h4
                              key={idx}
                              className="widget-title-item mb-1"
                              style={{
                                wordWrap: "break-word",
                                fontFamily: userData?.pageTheme?.pageFont,
                              }}
                            >
                              {t}
                            </h4>
                          ))}
                        </div>
                      )}
                    {userData?.userWidget?.description &&
                      userData?.userWidget?.description?.length > 0 && (
                        <div className="mb-3">
                          {userData?.userWidget?.description?.map((t, idx) => (
                            <p
                              key={idx}
                              className="widget-title-item mb-1"
                              style={{
                                fontFamily: userData?.pageTheme?.pageFont,
                              }}
                            >
                              {t}
                            </p>
                          ))}
                        </div>
                      )}
                    {userData?.userWidget?.note &&
                      userData?.userWidget?.note?.length > 0 && (
                        <div className="mb-3">
                          {userData?.userWidget?.note?.map((t, idx) => (
                            <p
                              key={idx}
                              className="widget-title-item mb-1"
                              style={{
                                fontFamily: userData?.pageTheme?.pageFont,
                              }}
                            >
                              {t}
                            </p>
                          ))}
                        </div>
                      )}
                    {userData?.userWidget?.email &&
                      userData?.userWidget?.email?.length > 0 && (
                        <div className="mb-3 email-widget-section">
                          {userData?.userWidget?.email?.map((item, idx) => (
                            <p className="mb-1" key={idx}>
                              <IoMail className="me-2" />{" "}
                              <a
                                href={`mailto:${item}`}
                                target="_blank"
                                style={{
                                  fontFamily: userData?.pageTheme?.pageFont,
                                }}
                              >
                                {item}
                              </a>
                            </p>
                          ))}
                        </div>
                      )}
                    {userData?.userWidget?.number &&
                      userData?.userWidget?.number?.length > 0 && (
                        <div className="mb-3 number-widget-section">
                          {userData?.userWidget?.number?.map((item, idx) => (
                            <p className="mb-1" key={idx}>
                              <LuPhone className="me-2" />{" "}
                              <a
                                href={`tel:${item}`}
                                target="_blank"
                                style={{
                                  fontFamily: userData?.pageTheme?.pageFont,
                                }}
                              >
                                {item}
                              </a>
                            </p>
                          ))}
                        </div>
                      )}
                    {userData?.userWidget?.card &&
                      userData?.userWidget?.card?.length > 0 && (
                        <div className="mb-3 card-widget-section">
                          {userData?.userWidget?.card?.map((item, idx) => {
                            const fullUrl =
                              item?.website && !item?.website.startsWith("http")
                                ? `https://${item?.website}`
                                : item?.website;
                            return (
                              <div
                                key={idx}
                                className="mb-3 bg-light p-2 rounded text-start"
                              >
                                {item?.website ? (
                                  <p className="mb-1">
                                    <TbWorld className="me-2" />{" "}
                                    <a
                                      href={fullUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        fontFamily:
                                          userData?.pageTheme?.pageFont,
                                      }}
                                    >
                                      {item?.website}
                                    </a>
                                  </p>
                                ) : null}
                                {item?.email ? (
                                  <p className="mb-1">
                                    <IoMail className="me-2" />{" "}
                                    <a
                                      href={`mailto:${item?.email}`}
                                      target="_blank"
                                      style={{
                                        fontFamily:
                                          userData?.pageTheme?.pageFont,
                                      }}
                                    >
                                      {item?.email}
                                    </a>
                                  </p>
                                ) : null}
                                {item?.number ? (
                                  <p className="mb-1">
                                    <LuPhone className="me-2" />{" "}
                                    <a
                                      href={`tel:${item?.number}`}
                                      target="_blank"
                                      style={{
                                        fontFamily:
                                          userData?.pageTheme?.pageFont,
                                      }}
                                    >
                                      {item?.number}
                                    </a>
                                  </p>
                                ) : null}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    {userData?.planType?.toLowerCase() !== "free" &&
                      userData?.userWidget?.mapDetails?.isShow &&
                      userData?.userWidget?.mapDetails?.lat &&
                      userData?.userWidget?.mapDetails?.lon && (
                        <div>
                          <div className="mb-2 rounded p-2 bg-light">
                            <MapContainer
                              center={[
                                userData?.userWidget?.mapDetails?.lat,
                                userData?.userWidget?.mapDetails?.lon,
                              ]}
                              zoom={15}
                              dragging={false}
                              scrollWheelZoom={false}
                              doubleClickZoom={false}
                              zoomControl={false}
                              style={{ width: "100%", height: "250px" }}
                            >
                              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                              <Marker
                                position={[
                                  userData?.userWidget?.mapDetails?.lat,
                                  userData?.userWidget?.mapDetails?.lon,
                                ]}
                                icon={icon}
                              ></Marker>
                            </MapContainer>
                            {userData?.userWidget?.mapDetails?.label && (
                              <div className="d-flex align-items-center justify-content-center mt-2">
                                <IoLocationSharp
                                  className="me-1"
                                  style={{ color: "#e50027", fontSize: "20px" }}
                                />
                                <p
                                  className="mb-0"
                                  style={{
                                    fontFamily: userData?.pageTheme?.pageFont,
                                  }}
                                >
                                  {userData?.userWidget?.mapDetails?.label}
                                </p>
                              </div>
                            )}
                            <a
                              href={`https://www.google.com/maps/search/?api=1&query=${userData?.userWidget?.mapDetails?.lat},${userData?.userWidget?.mapDetails?.lon}`}
                              target="_blank"
                              style={{
                                display: "block",
                                fontSize: "14px",
                                fontFamily: userData?.pageTheme?.pageFont,
                              }}
                            >
                              Open in Google Maps
                            </a>
                          </div>
                        </div>
                      )}
                    {/* YouTube */}
                    {youtubeId.length > 0 && (
                      <div className="pg-youtube-section">
                        <Row>
                          {youtubeId.map((id, index) => (
                            <div key={index} className="col-sm-12">
                              <div className="youtube-video-wrapper mb-4">
                                <iframe
                                  src={`https://www.youtube.com/embed/${id}`}
                                  title="YouTube video player"
                                  frameBorder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                  allowFullScreen
                                ></iframe>
                              </div>
                            </div>
                          ))}
                        </Row>
                      </div>
                    )}
                  </>
                )}

                {/* Event Poster modal remains global */}
                {userData?.userWidget?.eventPoster?.isShow && (
                  <EventPosterModal
                    eventPoster={userData?.userWidget?.eventPoster}
                  />
                )}
              </div>
            )}

          {/* Footer */}
          <div className="pg-footer">
            <Link
              to="/auth/signup"
              className="pg-join-btn"
              style={{ fontFamily: userData?.pageTheme?.pageFont }}
            >
              Join {userData.username} on BioME
            </Link>
            <div className="pg-footer-links mt-4">
              {/* <a href="#">Cookie Preferences</a> • <a href="#">Report</a> •{" "} */}
              <Link
                to="/biome/terms-condition"
                style={{ fontFamily: userData?.pageTheme?.pageFont }}
              >
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>

        {userData?.showAudio && userData?.audioUrl && (
          <CustomAudioPill audioUrl={userData?.audioUrl} />
        )}

        {showModal && (
          <div className="modal poster-modal" style={{ display: "flex" }}>
            <div className="modal-content">
              <Button
                variant="light"
                onClick={() => setShowModal(false)}
                style={{
                  position: "absolute",
                  top: "-10px",
                  right: "-10px",
                  borderRadius: "50%",
                  padding: "4px 8px",
                  zIndex: 10000,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                  fontFamily: userData?.pageTheme?.pageFont,
                }}
              >
                ✕
              </Button>
              {activeAlbum?.name && (
                <h3
                  className="mb-0 position-absolute p-1"
                  style={{
                    zIndex: "1",
                    fontSize: "18px",
                    width: "100%",
                    textAlign: "center",
                    top: 0,
                    left: 0,
                    background: "rgba(255, 255, 255, 0.4)",
                    fontFamily: userData?.pageTheme?.pageFont,
                  }}
                >
                  {activeAlbum?.name}
                </h3>
              )}
              <div
                className="albums-list"
                style={{ maxWidth: "300px", minWidth: "300px" }}
              >
                {activeAlbum?.media?.length > 0 ? (
                  <Carousel interval={null}>
                    {activeAlbum.media.map((m, idx) => (
                      <Carousel.Item key={idx}>
                        {m?.type?.startsWith("video/") ? (
                          <LoadingVideo
                            src={m?.url}
                            type={m?.type}
                            width="100%"
                            height="auto"
                            controls
                            {...(userData?.planType?.toLowerCase() === "yearly"
                              ? { autoPlay: true }
                              : {})}
                            skeletonHeight="250px"
                          />
                        ) : (
                          <LoadingImage
                            src={m.url}
                            alt={`Slide ${idx + 1}`}
                            className="d-block w-100"
                            width="100%"
                            height="auto"
                            style={{
                              objectFit: "contain",
                            }}
                            skeletonHeight="250px"
                          />
                        )}
                      </Carousel.Item>
                    ))}
                  </Carousel>
                ) : (
                  <p style={{ fontFamily: userData?.pageTheme?.pageFont }}>
                    No media available.
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
        {/* Form Modal */}
        {showFormModal && formModalData && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
            onClick={handleCloseFormModal}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "8px",
                padding: "20px",
                maxWidth: "500px",
                width: "90%",
                maxHeight: "80vh",
                overflowY: "auto",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <FormWidgetModal
                modalForm={formModalData}
                setModalForm={setFormModalData}
                widgetId={formModalData?.widgetId}
                isPublic={true}
                userName={userName}
                userData={userData}
                onSubmitForm={handleCloseFormModal}
                closeModal={handleCloseFormModal}
              />
            </div>
          </div>
        )}
        {/* Album Modal */}
        {/* <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{activeAlbum?.name || "Album"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {activeAlbum?.media?.length > 0 ? (
            <Carousel interval={null}>
              {activeAlbum.media.map((m, idx) => (
                <Carousel.Item key={idx}>
                  <img
                    className="d-block w-100"
                    src={m.url}
                    alt={`Slide ${idx + 1}`}
                    style={{ maxHeight: "70vh", objectFit: "contain" }}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            <p>No media available.</p>
          )}
        </Modal.Body>
      </Modal> */}
      </div>
    </div>
  );
};

export default PublicPage;
